import $ from 'jquery';

export default function init() {
  var $button = $('button.js-termi__button');
  var $openTooltip = null;
  var $activeButton = null;

  function getTermTooltipEl (button_el) {
      return $('#' + button_el.data("term"));
  }

  function calculateTooltipSizeAndPosition (tooltip_el, button_el) {
      $openTooltip = tooltip_el;
      $activeButton = button_el;

      var pos = button_el.offset();
      var pos_top = pos.top;
      var pos_left = pos.left;

      var window_width = $(window).scrollLeft() + $(window).width();

      var button_top_scroll_offset = pos_top - $(window).scrollTop();

      var tooltip_top_pos;
      var tooltip_left_pos;
      var margin = 10;

      // Check vertical positions
      if(button_top_scroll_offset < tooltip_el.outerHeight(true) + margin) {
          //The tooltip needs to be below the button
          tooltip_top_pos = button_el.position().top + button_el.outerHeight(true) + margin;
      } else {
          //The tooltip needs to be on top of the button
          tooltip_top_pos = button_el.position().top - tooltip_el.outerHeight(true) - margin;
      }

      tooltip_left_pos = pos_left;

      var tooltip_left_pos_offset = window_width - (pos_left + margin) - tooltip_el.outerWidth(true);

      if(tooltip_left_pos_offset < 0) {
          tooltip_left_pos += tooltip_left_pos_offset;
      }

      tooltip_el.css({top : tooltip_top_pos, left : tooltip_left_pos, visibility : ''});
      tooltip_el.addClass('open');
      tooltip_el.find('.js-term-content').focus();

      bindClose();
  }

  function bindClose() {
      $(window).on('click.closeTooltips', function(e) {
          var $target = $(e.target);

          if ($target.is('.js-term-close') ||
              (!$target.is('.js-termi__button') && !$target.closest('.js-termi-tooltip').length)) {
              closeTooltips();
          }
      });

      $(document).on('keyup.closeTermi', function(e) {
          if (e.keyCode === 27) { // esc
              closeTooltips();
          }
      });
  }

  function closeTooltips() {
      if ($openTooltip) {
          $openTooltip.removeClass('open');
          $openTooltip = null;
      }

      if ($activeButton) {
          $activeButton.focus();
          $activeButton = null;
      }

      $(window).off('click.closeTooltips');
      $(document).off('keyup.closeTermi');
  }

  $button.on({
      click : function (e) {
          e.preventDefault();

          var $termiButton = $(this);
          var isReclick = $activeButton && $termiButton.is($activeButton);

          closeTooltips();

          if (isReclick) {
              return;
          }

          var tooltip_el = getTermTooltipEl($termiButton);

          calculateTooltipSizeAndPosition(tooltip_el, $termiButton);
      },
  });
}
